import { BcStateContext} from '@bayclubs/state';
import { FeaturesModel } from '@bayclubs/employee-management-api';

export const FEATURES_FEATURE_KEY = 'pmFeatures';

export interface FeaturesStateModel {
    features: BcStateContext<FeaturesModel>;
}
